import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';

import { Input } from '@salesforce/design-system-react';

export const Currency = ({ enabled, required, label, fieldName, handleChange, error, defaultValue }) => {
  const [amount, setAmount] = useState(0);
  const [currencyFocused, setCurrencyFocus] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setAmount(defaultValue);
    }
  }, [defaultValue]);

  const usCurrency = new Intl.NumberFormat('en-US');

  return (
    <div className='time-currency input-numeric'>
      { currencyFocused ? <><Input
        label={label}
        type='number'
        name={fieldName}
        className='time-currency-input input-numeric-input'
        value={ amount }
        onChange={ (e) => {
          setAmount(e.target.value);
          handleChange(e, { fieldName, value: e.target.value });
        }}
        disabled={ !enabled }
        required={ required }
        errorText={error}
        onBlur={ () => {
          setCurrencyFocus(false);
        }}
      /></> :
      <><Input
        label={label}
        type='text'
        className='time-currency-input input-numeric-input'
        disabled={ !enabled }
        required={ required }
        value={`$ ${usCurrency.format(amount)}`}
        errorText={error}
        onFocus={ () => {
          setCurrencyFocus(true);
        }}
      /> </>
      }
    </div>
  );
};

Currency.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.number,
};
